import { MutationTree } from 'vuex';
import { RootState, SignupData } from './types';
import { mergeDeep } from '@/helpers.ts';

export const mutations: MutationTree<RootState> = {
  nextStep(state) {
    state.step += 1;
  },

  previousStep(state) {
    if (state.step === 1) {
      return;
    }

    state.step -= 1;
  },

  setSignupData(state, signupData: SignupData) {
    state.signupData = mergeDeep(state.signupData, signupData);
  },
};

export default mutations;
